<div class="drawer-content">
	<mat-nav-list>
		<mat-accordion>
			<mat-list-item
				routerLinkActive="active"
				routerLink="/transactions"
				appAppDrawer
				*ngIf="showTabTransactions"
			>
				<mat-icon mat-list-icon> attach_money</mat-icon>
				<div class="title" mat-line>{{ "transaction.sidebar" | translate }}</div>
			</mat-list-item>
			<mat-list-item
				routerLinkActive="active"
				routerLink="/quotations"
				appAppDrawer
				*ngIf="showTabQuotations"
			>
				<mat-icon mat-list-icon>request_quote</mat-icon>
				<div class="title" mat-line>{{ "quotation.sidebar" | translate }}</div>
			</mat-list-item>
			<mat-list-item
				routerLinkActive="active"
				routerLink="/user-management"
				appAppDrawer
				*ngIf="showTabUserManagement"
				>
				<mat-icon mat-list-icon>people</mat-icon>
				<div class="title" mat-line>{{ "auth.userManagement" | translate }}</div>
			</mat-list-item>
			<mat-list-item
				routerLinkActive="active"
				routerLink="/company"
				appAppDrawer
				*ngIf="showTabCompany"
				>
				<mat-icon mat-list-icon>apartment</mat-icon>
				<div class="title" mat-line>{{ "company.company" | translate }}</div>
			</mat-list-item>
		</mat-accordion>
	</mat-nav-list>
</div>

 
<!-- "f_quotations_renewal_listing"
1
: 
"f_quotations_transfer_ownership_listing"
2
: 
"f_transactions_listing"
3
: 
"f_user_management_create"
4
: 
"f_user_management_deactivate"
5
: 
"f_user_management_listing"
6
: 
"f_user_management_update" -->